import React from "react";
import Button, { ButtonTypes } from "../../../../components/Button";
import { Bar, Spacer, Status, StatusDot, StatusText, Actions } from "./styles";
import { SaveBarProps } from "./types";

export const SaveBar: React.FC<SaveBarProps> = ({
  isDirty,
  isSubmitting,
  onSave,
  onDiscard,
}) => {
  const fullStatusText = isDirty
    ? "You have unsaved changes"
    : "No unsaved changes";
  const saveLabel = isSubmitting ? "Saving..." : "Save changes";

  return (
    <>
      <Spacer $isDirty={isDirty} aria-hidden="true" />
      <Bar $isDirty={isDirty} role="status" aria-live="polite">
        <Status>
          <StatusDot $isDirty={isDirty} aria-hidden="true" />
          <StatusText $isDirty={isDirty}>
            <span className="label-full">{fullStatusText}</span>
            <span className="label-short">Unsaved changes</span>
          </StatusText>
        </Status>
        <Actions>
          {isDirty ? (
            <Button
              type={ButtonTypes.revert}
              disabled={isSubmitting}
              onClick={onDiscard}
              aria-label="Discard changes"
            >
              Discard
            </Button>
          ) : null}
          <Button
            type={ButtonTypes.primary}
            disabled={isSubmitting || !isDirty}
            onClick={onSave}
            aria-label={isDirty ? "Save changes" : "No changes to save"}
          >
            {saveLabel}
          </Button>
        </Actions>
      </Bar>
    </>
  );
};
